import { cn } from 'noddi-ui-common';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

// A simple centered screen wrapper for transient screens (booking confirmation / builders)
export const TransitionScreenWrapper = ({ children, className }: Props) => {
  return <div className={cn('flex min-h-[50vh] items-center justify-center px-5 py-10', className)}>{children}</div>;
};
